<template>
  <v-container fluid class="account-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Account</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <p class="text-h5">New Account</p>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-text-field
                        type="number"
                          class="mb-4"
                          v-model="account.accountnum"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Account Num"
                          persistent-hint
                          single-line hint="Enter the account num">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="account.accountcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Account Code"
                          persistent-hint
                          single-line hint="Enter the account Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="account.accountname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Account Name"
                          persistent-hint
                          single-line hint="Enter the account name">
                        </v-text-field>
                          <v-switch
                            v-model="account.accountstatus"
                            color="primary"
                            v-bind:label="account.accountstatus"
                            value="New"
                          ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items=Object.keys(classes)
                          v-model="account.accountclass"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Class"
                          persistent-hint
                          single-line hint="Please choose the account class">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=classes[account.accountclass]
                          v-model="account.accountsubclass"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Subclass"
                          persistent-hint
                          single-line hint="Please choose the account subclass">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=accounttype
                          v-model="account.accounttype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the account type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=accountsubtype
                          v-model="account.accountsubtype"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Subtype"
                          persistent-hint
                          single-line hint="Please choose the account subtype">
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/account/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertAccount()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      account: {
        accountstatus: 'New'
      },
      classes: {
        'Asset': ['Cash', 'Bank', 'Current Asset', 'Other Asset'],
        'Liability': ['Current Liability', 'Other Liability', 'Loan Payable'],
        'Equity': ['Equity', 'Retained Earnings', 'Other Equity'],
        'Revenue': ['Sales Income', 'Sales Discount', 'Service Income', 'Other Income'],
        'Cost': ['Cost of Goods Sold', 'Other Cost of Goods Sold'],
        'Expense': ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
        'Payroll': ['Salary', 'Salary Items', 'Employee Benefit', 'Flexible Savings', 'Flexible Work', 'Claims'],
        'Other': ['Other Income', 'Other Expense'],
      },

      accounttype: ['Credit', 'Debit'],
      accountsubtype: ['Account', 'Addition', 'Deduction', 'Contribution', 'Benefit', 'Saving', 'Flexible Work', 'Expense Claim', 'Medical Claim', 'Other'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Account', ['insertAccountRequest','getAccountsRequest']),
    checkError(){
      if(!this.account.accountcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.account.accountname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.account.accounttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.account.accountsubtype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.account.accountclass){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertAccount() {
      if(!this.checkError()) return;
      await this.insertAccountRequest(this.account);
      router.push('/account/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.account.accountimage = file;
      this.account.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Account', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
